@if (showPage) {
  <p-selectbutton
    [(ngModel)]="selectedFilter"
    [options]="translatedOptions"
    optionLabel="label"
    optionValue="value"
    (onChange)="onFilterChange()"
    size="small"
  >
    <ng-template #item let-item>
      <div class="flex items-center gap-1.5">
        <lucide-icon [name]="item.icon" [size]="14"></lucide-icon>
        @if (isSidebarCollapsed()) {
          <span class="hidden lg:inline">{{ item.label }}</span>
        } @else {
          <span class="hidden xl:inline">{{ item.label }}</span>
        }
      </div>
    </ng-template>
  </p-selectbutton>
}
